import { createContext, useContext } from 'react'
import { useUser, useClerk } from '@clerk/react'

const AuthContext = createContext()

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

/**
 * Thin wrapper around Clerk authentication.
 * Provides backward-compatible API for existing components.
 */
export function AuthProvider({ children }) {
  const { isSignedIn, isLoaded, user: clerkUser } = useUser()
  const { signOut } = useClerk()

  // Map Clerk user to the shape our components expect
  const user = isSignedIn && clerkUser ? {
    id: clerkUser.id,
    email: clerkUser.primaryEmailAddress?.emailAddress,
    name: clerkUser.fullName || clerkUser.firstName || clerkUser.primaryEmailAddress?.emailAddress?.split('@')[0],
    imageUrl: clerkUser.imageUrl || null,
  } : null

  const value = {
    user,
    loading: !isLoaded,
    error: null,
    isAuthenticated: !!isSignedIn,
    logout: () => signOut(),
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
